if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        this.btnClosePopup = this.querySelector('.btnClosePopup');
        if(this.btnClosePopup){
          this.btnClosePopup.addEventListener('click',  this.closePopup.bind(this));
        }
        
        this.btnCartPopup = this.querySelector('.btnCartPopup');
        if(this.btnCartPopup){
          this.btnCartPopup.addEventListener('click', this.closePopupTwo.bind(this));
        }

        this.querySelectorAll('.purchaseItem .variant-selector').forEach((item) => {
          if(item){
            item.addEventListener('change', this.variantChange.bind(this));
          }
        });

        this.btnAddToCartPurchase = this.querySelector('.btnAddToCartPurchase');
        if(this.btnAddToCartPurchase){
          this.btnAddToCartPurchase.addEventListener('click', this.addPurchase.bind(this));
        }
        
        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          const customFormObj = $(this).find('.containerFormPopup');
          
          setTimeout(() => {
            let openCartDrawer = !quickAddDrawer && theme.settings.afterAtc === 'drawer';
            if(customFormObj.length){
              openCartDrawer = false;
              customFormObj.addClass('active');
            }
            
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                openCartDrawer
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        //update data custom popup
        ProductForm.updateProductAdded(newCartData, data.variant_id);
        
        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }

    /**
     * Custom popup
     */
    static updateProductAdded(data, variant_id){
      const itemFilter = data.items.filter((item) => item.variant_id === variant_id);
      if(itemFilter.length){
        const obj = $('.containerFormPopup');
        obj.find('.productImage').html('<img src="'+itemFilter[0].image+'" alt=""/>');
        obj.find('.productTitle').html(itemFilter[0].product_title);
        let productVariant = '';
        if(itemFilter[0].options_with_values.length){
          $.each(itemFilter[0].options_with_values, function(index, val){
            productVariant += '<div class="productVariantItem"><span>'+val.name+':</span> '+val.value+'</div>';
          })
        }        
        obj.find('.productVariant').html(productVariant);
        const price = new Intl.NumberFormat(theme.settings.locale, {
          style: "currency",
          currency: theme.settings.curreny,
          minimumFractionDigits: 0,
        }).format(itemFilter[0].original_price / 100);
        obj.find('.productPrice').html(price+'x'+itemFilter[0].quantity);
      }
    }

    closePopup(evt){
      evt.preventDefault();
      $('.containerFormPopup').removeClass('active');
    }

    closePopupTwo(evt){
      evt.preventDefault();
      $('.containerFormPopup').removeClass('active');
      if (this.cartDrawer){
        this.cartDrawer.open();
      }
    }

    variantChange(evt){
      const parentItem = evt.target.closest('.purchaseItem'); 
      const selectProductInput = parentItem.querySelector('input[type="checkbox"]'); 

      if (selectProductInput) {
        selectProductInput.value = evt.target.value; // Set the input's value as well
      }
    }

    async addPurchase(evt){
      evt.preventDefault();
      var productList = [];
      const parentItem = evt.target.closest('.customPurchase');
      parentItem.querySelectorAll('.purchaseItem input[type="checkbox"]:checked').forEach(function(element){
        if(element){
          const id = element.value;
          let qty = 1;
          const qtyParent = element.closest('.purchaseItem');
          const qtyItem = qtyParent.querySelector('input[type="number"]');
          const productId = qtyParent.querySelector('.variant-selector');
          
          if(qtyItem){
            qty = qtyItem.value;
          }
          if(productId){
            productList.push({
              id: id,
              quantity: qty,
              // product_id: productId.getAttribute('data-product-id'),
              // product_url: productId.getAttribute('data-product-url')
            });
          }
        }
      });

      if(productList.length){
        this.ajaxProduct(productList);
      }
    }
    
    async ajaxProduct(productList) {
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: productList, sections_url: window.location.pathname, sections: sections })
      };

      try{
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();
        
        const response = await fetch(`${theme.routes.cartAdd}.js`, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status){
          this.setErrorMsgState(error);
        }

        if (!response.ok){
          throw new Error(response.status);
        }

        ProductForm.updateCartIcon(data);
        
        setTimeout(() => {
          $('.containerFormPopup').removeClass('active');
          
          if (this.cartDrawer) {
            this.cartDrawer.renderContents(
              data,
              true
            );
          } 
        }, 700);
        
        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();

        const obj = this;
        $.each(data.items, function(idx, dataItem){
          const itemInOldCart = oldCartData.items.filter(
            (item) => item.variant_id === dataItem.variant_id
          )[0];
  
          if (itemInOldCart) {
            obj.dispatchEvent(new CustomEvent('on:line-item:change', {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: dataItem.variant_id,
                oldQuantity: itemInOldCart.quantity,
                newQuantity: (itemInOldCart.quantity === dataItem.quantity)
                  ? itemInOldCart.quantity : dataItem.quantity
              }
            }));
          } else {
            obj.dispatchEvent(new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: dataItem.variant_id
              }
            }));
          }
        });
      }
      catch(error){
        this.setErrorMsgState(error);
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
